import img from 'app/assets/icons/single-select-arrow.svg';

import { FormItemSingleChoice } from '../types';
import Select from './Select/Select';

type Props = { item: FormItemSingleChoice; isSubmitted: boolean };

export function ContactFormSingleChoice({ item }: Props) {
  const hasErrors = item.errors?.length;

  return (
    <div className="flex flex-col gap-2">
      <div className="flex items-center text-sm gap-1">
        <label
          htmlFor={item.ref_id}
          dangerouslySetInnerHTML={{ __html: item.label }}
          className="flex items-center"
        />
        {!item.required && <span>(optional)</span>}
      </div>
      <Select
        id={item.ref_id}
        name={item.ref_id}
        defaultValue={typeof item.value === 'string' ? item.value : undefined}
        style={{
          backgroundImage: `url(${img})`,
          backgroundRepeat: 'no-repeat',
          backgroundPosition: 'right 10px center',
        }}
        required={item.required}
        className="px-[14px] py-3 border md:text-sm rounded-[8px] border-typography-divider outline-typography-divider hide-select-arrow w-full"
      >
        {item.choices.map((choice: string) => (
          <option key={choice}>{choice}</option>
        ))}
      </Select>
      {hasErrors && item.errors?.length ? (
        <div className="text-xs -mt-1 text-[#FF3323]">{item.errors?.join(', ')}</div>
      ) : null}
    </div>
  );
}
